import React from 'react';
import { OptimizedImage } from 'components/OptimizedImage';
import { getInitials } from 'utils';
import { Tooltip } from 'styles';
import styled from 'styled-components';
import { GetArchivedOrdersQuery } from 'data/__generated__';

export interface TotemUserPictureProps {
    profile: GetArchivedOrdersQuery['archivedOrders']['archivedOrders'][number]['user']['profile'] | null | undefined;
}

export const TotemUserPicture: React.FC<TotemUserPictureProps> = ({ profile }) => {
    const { firstname, lastname, imageUrl } = profile ?? {};
    return (
        <>
            {imageUrl ? (
                <OptimizedImage
                    width={40}
                    src={imageUrl}
                    hasBorderRadius
                    data-for="userPicture"
                    data-tip={`${firstname ?? ''} ${lastname ?? ''}`}
                />
            ) : (
                firstname &&
                lastname && (
                    <PicturePlaceholder data-for="userPicture" data-tip={`${firstname} ${lastname}`}>
                        {getInitials(firstname, lastname)}
                    </PicturePlaceholder>
                )
            )}
            {((firstname && lastname) || imageUrl) && (
                <Tooltip id="userPicture" type="dark" effect="solid" place="bottom" />
            )}
        </>
    );
};

const PicturePlaceholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin: 0;
    background-color: ${({ theme: { colors } }) => colors.black};
    color: white;
    border-radius: 50%;
`;
